module.exports = __webpack_public_path__ + "img/set_message.5a4ceec4.svg";